export default {
      id: "icon-chevron-usage",
      viewBox: "0 0 14 9",
      url: __webpack_public_path__ + "icons.svg#icon-chevron",
      toString: function () {
        return this.url;
      }
    }